import React, { Component, ErrorInfo, ReactNode } from 'react';
import { generateErrorReferenceNumber } from '../utils/errorUtils';
import { ErrorBoundaryFallback } from './ErrorBoundary';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class CustomErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log the error for tracking
    console.error('Error caught by CustomErrorBoundary:', error);
    console.error('Component Stack:', errorInfo.componentStack);
    
    // Here you could send the error to an error tracking service
  }

  resetError = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryFallback 
          error={this.state.error || new Error('Unknown error')} 
          resetError={this.resetError} 
        />
      );
    }

    return this.props.children;
  }
}

export default CustomErrorBoundary;